import axios from "axios";
const API_BASE_URL = "https://fishbot-backend.herokuapp.com/";

export const statslookupApi = (theUsername) => axios.create({
  baseURL: API_BASE_URL + "api/playerstatslookup/"+theUsername,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
